import { IconHamburger } from '../../assets/icons/IconHamburger';
import { classNames } from '../../helpers/common';
import { NavigationMenu } from '../../types';
import { Menu } from '../Menu';
import { useState, useEffect, useRef } from 'react';
import logo from '../../assets/images/logo_ngolo_branca.png';
import logoPreta from '../../assets/images/NGOLO_PRETA.png';

interface HeaderProps {
  homepage?: boolean;
  goTo: (href: string) => void;
}

export const Header: React.FC<HeaderProps> = ({ homepage, goTo }) => {
  const navigation: NavigationMenu[] = [
    { name: 'Início', href: '/', current: true },
    { name: 'História', href: '/historia', current: false },
    {
      name: 'O Grupo',
      href: '#',
      current: false,
      submenu: [
        { name: 'Mestre Dionizio', href: '/mestre-dionizio', current: false },
        // { name: 'Membro do Grupo', href: '#', current: false },
        { name: 'Sistema de Graduação', href: '/graduacao', current: true },
      ],
    },
    { name: 'Eventos', href: '/eventos', current: false },
    { name: 'Artigos', href: '/articles', current: false },
    // { name: 'Mídia', href: '#', current: false },
    // { name: 'Contato', href: '#', current: false },
  ];

  const [openMenu, setOpenMenu] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const handleDropdown = (itemName: string) => {
    setDropdownOpen(dropdownOpen === itemName ? null : itemName);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest('.submenu') &&
        !dropdownRef.current.parentElement?.contains(event.target as Node)
      ) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <header
      className={classNames(
        homepage ? 'bg-header absolute top-0 left-0' : 'bg-white',
        'w-full shadow-xs'
      )}
    >
      <div className="container mx-auto h-28 flex justify-between items-center">
        <div className="flex flex-1 items-center sm:items-stretch sm:justify-start">
          <div className="flex flex-shrink-0 items-center">
            <a href="#" onClick={() => goTo('/')}>
              <img
                className="w-auto h-[80px] hidden lg:block"
                src={homepage ? logo : logoPreta}
                alt="N`GOLO"
              />
              <img
                className="block w-auto h-[80px] lg:hidden"
                src={logoPreta}
                alt="NGOLO Capoeira"
              />
            </a>
          </div>
          <div className="hidden sm:ml-6 sm:flex items-center">
            <nav className="mr-auto ml-8 space-x-8 flex">
              {navigation.map((item) => (
                <div key={item.name} className="relative" ref={dropdownRef}>
                  <a
                    href="#"
                    className={classNames(
                      homepage ? 'text-white' : 'text-black',
                      'font-dmsans font-normal'
                    )}
                    onClick={(e) => {
                      if (item.submenu) {
                        e.preventDefault();
                        handleDropdown(item.name);
                      } else {
                        goTo(item.href);
                      }
                    }}
                    aria-current={item.current ? 'page' : undefined}
                  >
                    {item.name}
                  </a>
                  {item.submenu && dropdownOpen === item.name && (
                    <div className="absolute mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                      <div className="py-1">
                        {item.submenu.map((subitem) => (
                          <a
                            key={subitem.name}
                            href="#"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-200"
                            onClick={() => {
                              goTo(subitem.href);
                            }}
                          >
                            {subitem.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </nav>
          </div>
        </div>
        <div>
          <ul className="flex items-center space-x-1 md:space-x-5">
            <li className="flex items-center sm:hidden">
              <button
                type="button"
                className={classNames(
                  homepage
                    ? 'bg-white text-heading'
                    : 'bg-[#222222] text-white',
                  'flex justify-center items-center w-[46px] h-[46px] rounded-full focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800'
                )}
                aria-controls="mobile-menu"
                aria-expanded="false"
                onClick={() => setOpenMenu(true)}
              >
                <span className="sr-only">Open main menu</span>
                <IconHamburger
                  className={classNames(
                    homepage ? 'text-[#222222]' : 'text-white',
                    'h-[22px]'
                  )}
                />
              </button>
            </li>
            <li className="hidden md:block">
              <a
                href="#"
                className={classNames(
                  homepage ? 'text-white' : ' text-neutro-b-400',
                  'font-dmsans font-normal'
                )}
                onClick={() => goTo('/criar-conta')}
              >
                Criar conta
              </a>
            </li>
          </ul>
        </div>
        <Menu visible={openMenu} onSetVisible={setOpenMenu} goTo={goTo} />
      </div>
    </header>
  );
};
